import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AppContext from "./Context/AppContext";

import { useEffect, useState } from "react";
import Login from "./pages/Login";
import Template from "./layout/Template";
import Homepage from "./pages/Homepage";
import StatPage from "./pages/StatPage"
import { get } from "./utils/fetcher";
import Messenger from "./pages/Messenger";
import Server from "./pages/Server";
import ServerConf from "./pages/ServerConf";
import Paiement from "./pages/Paiement";
import MessageUser from "./pages/MessageUser";
import ListDomain from "./pages/ListDomain";
import MessageUserSport from "./pages/MessageUserSport";
import PaiementSport from "./pages/PaiementSport";
import Parametre from "./pages/Parametre";
import UserBackup from "./pages/UserBackup";
import UserProject from "./pages/UserProject";
import PaymentSettings from "./pages/PaymentSettings";
import PlatformPayments from "./pages/PlatformPayments";
import PlatformSupport from "./pages/PlatformSupport";
import Invitations from "./pages/Invitations";
import Referral from "./pages/Referral";
import Emails from "./pages/Emails";
import EmailEditor from "./pages/EmailEditor";



function App() {

  const [currentPage, setCurrentPage] = useState("")
  const [loadInit, setLoadInit] = useState(true)
  const [mapUrl, setMapUrl] = useState(null)

  const [sideComponent, setSideComponent] = useState(null)
  const [sideSheetOpen, setSideSheetOpen] = useState(false)

  const init = async () => {
    const responseUrl = await get('/config/get_url');
    if (responseUrl) {
      setMapUrl(responseUrl)
    }
    setLoadInit(false)
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <Router>
      <AppContext.Provider value={{ currentPage, sideComponent, setSideComponent, setCurrentPage, mapUrl, loadInit, sideSheetOpen, setSideSheetOpen }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/stat" element={<Template><StatPage /></Template>} />
          <Route path="/messenger" element={<Template><Messenger /></Template>} />
          <Route path="/paiement" element={<Template><Paiement /></Template>} />
          <Route path="/paiement_sport" element={<Template><PaiementSport /></Template>} />
          <Route path="/server" element={<Template><Server /></Template>} />
          <Route path="/server_conf" element={<Template><ServerConf /></Template>} />
          <Route path="/domain_list" element={<Template><ListDomain /></Template>} />
          <Route path="/user_backup" element={<Template><UserBackup /></Template>} />
          <Route path="/user_project" element={<Template><UserProject /></Template>} />
          <Route path="/parametres_paiement" element={<Template><PaymentSettings /></Template>} />
          <Route path="/paiements_plateformes" element={<Template><PlatformPayments /></Template>} />
          <Route path="/support_plateformes" element={<Template><PlatformSupport /></Template>} />
          <Route path="/invitations" element={<Template><Invitations /></Template>} />
          <Route path="/parrainage" element={<Template><Referral /></Template>} />
          <Route path="/emails" element={<Template><Emails /></Template>} />
          <Route path="/emails/:id" element={<Template><EmailEditor /></Template>} />
          <Route
            path="/message_user"
            element={<Template><MessageUser /></Template>}
          />
          <Route
            path="/message_user_sport"
            element={<Template><MessageUserSport /></Template>}
          />

          <Route
            path="/message_user/:id"
            element={<Template><MessageUser /></Template>}
          />
          <Route path="/parametre" element={<Template><Parametre /></Template>} />
          <Route path="/" element={<Template><Homepage /></Template>} />
        </Routes>
      </AppContext.Provider>
    </Router>
  );
}

export default App;
